import {
  getLicensesWithAssignedPermission,
  hasLicenseWithStatus,
} from "./LicenseUtils";

export const getAIRecommendationFeedback = ({
  userLicenses = [],
  licensePermissionId,
  licenseStatus,
  feedbackTypes,
  dialogTypes,
}) => {
  const licensesWithPermission = getLicensesWithAssignedPermission(
    userLicenses,
    licensePermissionId,
  );

  if (hasLicenseWithStatus(licensesWithPermission, licenseStatus.active)) {
    return {
      type: null,
      messageKey: null,
      dialogType: dialogTypes.WARNING,
      headerKey: null,
      descriptionKey: null,
      requiresConfirmation: false,
    };
  }

  if (
    hasLicenseWithStatus(licensesWithPermission, licenseStatus.expiringSoon)
  ) {
    return {
      type: feedbackTypes.WARNING,
      messageKey: "licenseWarnings.aiRecommendationsExpiringSoonWarning",
      dialogType: dialogTypes.WARNING,
      headerKey: "licenseWarnings.aiRecommendationsExpiringSoonHeader",
      descriptionKey:
        "licenseWarnings.aiRecommendationsExpiringSoonDescription",
      requiresConfirmation: true,
    };
  }

  const hasPermissionAnyStatus = licensesWithPermission.length > 0;

  if (
    hasPermissionAnyStatus ||
    hasLicenseWithStatus(licensesWithPermission, licenseStatus.expired) ||
    hasLicenseWithStatus(licensesWithPermission, licenseStatus.terminated)
  ) {
    return {
      type: feedbackTypes.ERROR,
      messageKey: "licenseWarnings.aiRecommendationsWarning",
      dialogType: dialogTypes.ERROR,
      headerKey: "licenseWarnings.aiRecommendationsNotAvailableHeader",
      descriptionKey:
        "licenseWarnings.aiRecommendationsNotAvailableDescription",
      requiresConfirmation: true,
    };
  }

  return {
    type: null,
    messageKey: null,
    dialogType: dialogTypes.WARNING,
    headerKey: null,
    descriptionKey: null,
    requiresConfirmation: false,
  };
};
